import { Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import { guestStatus, clearGuest } from '../utils/guest_session';

// Stands in for ProtectedRoute on exactly /gathering and /gathering/call. A
// Gathering guest (utils/guest_session.js) has no Keycloak session, so they
// skip Keycloak entirely; everyone else goes through the normal login and
// onboarding gate. A guest whose pass has run out is sent back to the join
// page rather than into a Keycloak login they have no account for.
const GatheringAccessGate = ({ children }) => {
    const status = guestStatus();
    if (status === 'active') return children;
    if (status === 'expired') {
        clearGuest();
        return <Navigate to="/gathering/join?expired=1" replace />;
    }
    return <ProtectedRoute>{children}</ProtectedRoute>;
};

export default GatheringAccessGate;
